// import React, { useEffect, useState } from 'react';
// import { BASE_URL } from '../../api/apiClient';
// /* ────────────────────────────────────────────────────────────────────────
//  * Helpers — status === 0 means "removed", everything else sorts by order.
//  * byOrder falls back to original array position when two items share the
//  * same order value, so duplicate orders still render in a consistent,
//  * predictable sequence.
//  * ──────────────────────────────────────────────────────────────────── */

// const isActive = (item) => item.status !== 0;

// const byOrder = (arr) =>
//   arr
//     .map((item, index) => ({ item, index }))
//     .sort((a, b) => {
//       const diff = (a.item.order ?? 0) - (b.item.order ?? 0);
//       return diff !== 0 ? diff : a.index - b.index;
//     })
//     .map(({ item }) => item);

// /* ────────────────────────────────────────────────────────────────────────
//  * Reusable column for Care / Resources / Company — same heading+links
//  * shape, rendered with whatever links survive the status/order pass.
//  * ──────────────────────────────────────────────────────────────────── */

// function FooterLinkColumn({ heading, links }) {
//   return (
//     <div className="flex flex-col gap-3">
//       <h4
//         className="ava-text-subheading underline underline-offset-4"
//         style={{ color: 'var(--white)' }}
//       >
//         {heading}
//       </h4>
//       <ul className="flex flex-col gap-2">
//         {links.map((link) => (
//           <li key={link.id}>
//             <a
//               href={link.href}
//               className="ava-text-footer transition-colors duration-200"
//               style={{ color: 'white' }}
//             >
//               {link.label}
//             </a>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// const Footer = () => {
//   const [footer, setFooter] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Newsletter is currently commented out below (kept from the original
//   // markup). State left in place in case you re-enable it.
//   const [email, setEmail] = useState('');
//   const [submitted, setSubmitted] = useState(false);

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await fetch(`${BASE_URL}/api/femcare/footer/`);
//         const json = await res.json().catch(() => ({}));
//         if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
//         setFooter(json?.sections?.footer ?? null);
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!email.trim()) return;
//     setSubmitted(true);
//     setEmail('');
//   };

//   // Don't render anything while loading, on error, if the footer failed to
//   // load, or if it's been explicitly disabled in the editor.
//   if (loading || error || !footer || !footer.enabled) return null;

//   const { logo, tagline, newsletter, care, company, resources, contact, partnership, legal } = footer;

//   // Order the three link columns themselves by their own `order` field, and
//   // drop any column whose `status` has been set to 0 (removed).
//   const columns = byOrder(
//     [
//       { key: 'care', heading: care.heading, links: care.links, order: care.order, status: care.status },
//       {
//         key: 'resources',
//         heading: resources.heading,
//         links: resources.links,
//         order: resources.order,
//         status: resources.status,
//       },
//       {
//         key: 'company',
//         heading: company.heading,
//         links: company.links,
//         order: company.order,
//         status: company.status,
//       },
//     ].filter(isActive)
//   );

//   const legalLinks = byOrder((legal.links || []).filter(isActive));

//   return (
//     <footer className="w-full">
//       {/* ── Main footer body ── */}
//       <div className="w-full ava-footer-bg">
//         <div className="  mx-auto px-6 md:px-8 py-10 md:py-14">
//           {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8"> */}
//           <div className='flex flex-wrap justify-between ' style={{gap:"2rem"}}>
//             {/* ── Col 1: Logo + tagline ── */}
//             <div className="flex flex-col gap-4">
//               <a href="#home" className="inline-flex items-center gap-3 w-fit">
//                 <img src={logo.src} alt={logo.alt} className="h-12 w-auto" />
//               </a>
//               <p className="ava-text-body" style={{ maxWidth: '200px', color: 'var(--white)' }}>
//                 {tagline}
//               </p>
//             </div>


//             {/* ── Cols: Care / Resources / Company, in editor-defined order ── */}
//             {columns.map((col) => (
//               <FooterLinkColumn
//                 key={col.key}
//                 heading={col.heading}
//                 links={byOrder((col.links || []).filter(isActive))}
//               />
//             ))}

//             {/* ── Col: Contact + Partnership ── */}
//             <div className="flex flex-col gap-3">
//               <h4
//                 className="ava-text-subheading underline underline-offset-4"
//                 style={{ color: 'var(--white)' }}
//               >
//                 {contact.heading}
//               </h4>

//               <ul className="flex flex-col gap-3">
//                 <li className="flex items-start gap-2">
//                   <img src="/images/VectorMobile.svg" alt="Phone" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <a
//                     href={`tel:${contact.phone.replace(/\s/g, '')}`}
//                     className="ava-text-footer transition-colors duration-200"
//                     style={{ color: 'var(--white)' }}
//                   >
//                     {contact.phone}
//                   </a>
//                 </li>

//                 <li className="flex items-start gap-2">
//                   <img src="/images/GroupMail.svg" alt="Email" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <a
//                     href={`mailto:${contact.email}`}
//                     className="ava-text-footer"
//                     style={{ color: 'var(--white)' }}
//                   >
//                     {contact.email}
//                   </a>
//                 </li>

//                 <li className="flex items-start gap-2" style={{ color: 'var(--white)' }}>
//                   <img src="/images/GroupLocation.svg" alt="Location" className="w-4 h-4 mt-0.5 flex-shrink-0" />
//                   <span className="ava-text-footer" style={{ color: 'var(--white)' }}>
//                     {contact.addressLine1}
//                     <br />
//                     {contact.addressLine2}
//                   </span>
//                 </li>
//               </ul>

//               {/* Partnership — left commented out, same as original markup */}
//               {/*
//               {partnership && (
//                 <div className="mt-2">
//                   <h5 className="font-semibold text-sm" style={{ color: 'var(--text-dark)' }}>
//                     {partnership.label}
//                   </h5>
//                   {partnership.logos && partnership.logos.length > 0 && (
//                     <div className="flex items-center gap-3 mt-2">
//                       {byOrder(partnership.logos.filter(isActive)).map((logo) => (
//                         <img
//                           key={logo.id}
//                           src={logo.src}
//                           alt={logo.alt}
//                           className="h-8 w-auto object-contain"
//                         />
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}
//               */}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── Bottom bar ── */}
//       <div className="w-full ava-footer-bg">
//         <div className="px-6 md:px-8 py-4">
//           <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
//             {/* Copyright */}
//             <p className="ava-text-footer text-white opacity-90 text-center sm:text-left">{legal.copyright}</p>

//             {/* Legal links, filtered + ordered */}
//             <div className="flex items-center gap-1 ava-text-footer text-white opacity-90">
//               {legalLinks.map((link, index) => (
//                 <React.Fragment key={link.id}>
//                   {index > 0 && <span className="opacity-60 px-1">|</span>}
//                   <a href={link.href} className="hover:underline transition-opacity hover:opacity-100">
//                     {link.label}
//                   </a>
//                 </React.Fragment>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../api/apiClient';

/* ────────────────────────────────────────────────────────────────────────
 * Helpers
 * ──────────────────────────────────────────────────────────────────────── */

const isActive = (item) => item.status !== 0;

const byOrder = (arr) =>
  arr
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff = (a.item.order ?? 0) - (b.item.order ?? 0);
      return diff !== 0 ? diff : a.index - b.index;
    })
    .map(({ item }) => item);

function FooterLinkColumn({ heading, links }) {
  return (
    <div className="flex flex-col gap-3">
      <h4
        className="ava-text-subheading underline underline-offset-4"
        style={{ color: 'var(--white)' }}
      >
        {heading}
      </h4>

      <ul className="flex flex-col gap-2">
        {links.map((link) => {
          const isExternal = /^https?:\/\//.test(link.href);

          return (
            <li key={link.id}>
              <a
                href={link.href}
                target={isExternal ? '_blank' : undefined}
                rel={isExternal ? 'noopener noreferrer' : undefined}
                className="ava-text-footer transition-colors duration-200"
                style={{ color: 'white' }}
              >
                {link.label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const Footer = () => {
  const [footer, setFooter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/`);
        const json = await res.json();
        console.log(json,"this is the json");

        if (!res.ok) {
          throw new Error(json?.error || `Request failed (${res.status})`);
        }

        setFooter(json?.sections?.footer ?? null);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!email.trim()) return;

  //   setSubmitted(true);
  //   setEmail('');
  // };

  if (loading || error || !footer || !footer.enabled) return null;

  const {
    logo,
    tagline,
    newsletter,
    linkSections = [],
    contact,
    partnership,
    legal,
  } = footer;

  const columns = byOrder(linkSections.filter(isActive));

  const legalLinks = byOrder((legal?.links || []).filter(isActive));

  return (
    <footer className="w-full">
      {/* Main Footer */}
      <div className="w-full ava-footer-bg">
        <div className="mx-auto px-6 md:px-8 py-10 md:py-14">
          <div
            className="flex flex-wrap justify-between"
            style={{ gap: '2rem' }}
          >
            {/* Logo */}
            <div className="flex flex-col gap-4">
              <a href="/" className="inline-flex items-center gap-3 w-fit">
                <img
                  src={logo?.src}
                  alt={logo?.alt}
                  className="h-12 w-auto"
                />
              </a>

              <p
                className="ava-text-body"
                style={{
                  maxWidth: '200px',
                  color: 'var(--white)',
                }}
              >
                {tagline}
              </p>
            </div>

            {/* Dynamic Sections */}
            {columns.map((section) => (
              <FooterLinkColumn
                key={section.id}
                heading={section.heading}
                links={byOrder((section.links || []).filter(isActive))}
              />
            ))}

            {/* Contact */}
            <div className="flex flex-col gap-3">
              <h4
                className="ava-text-subheading underline underline-offset-4"
                style={{ color: 'var(--white)' }}
              >
                {contact?.heading}
              </h4>

              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <img
                    src="/images/VectorMobile.svg"
                    alt="Phone"
                    className="w-4 h-4 mt-0.5 flex-shrink-0"
                  />

                  <a
                    href={`tel:${contact?.phone?.replace(/\s/g, '')}`}
                    className="ava-text-footer"
                    style={{ color: 'white' }}
                  >
                    {contact?.phone}
                  </a>
                </li>

                <li className="flex items-start gap-2">
                  <img
                    src="/images/GroupMail.svg"
                    alt="Email"
                    className="w-4 h-4 mt-0.5 flex-shrink-0"
                  />

                  <a
                    href={`mailto:${contact?.email}`}
                    className="ava-text-footer"
                    style={{ color: 'white' }}
                  >
                    {contact?.email}
                  </a>
                </li>

                {/* <li
                  className="flex items-start gap-2"
                  style={{ color: 'white' }}
                >
                  <img
                    src="/images/GroupLocation.svg"
                    alt="Location"
                    className="w-4 h-4 mt-0.5 flex-shrink-0"
                  />

                  <span
                    className="ava-text-footer"
                    style={{ color: 'white' }}
                  >
                    {contact?.addressLine1}
                    <br />
                    {contact?.addressLine2}
                  </span>
                </li> */}

             <li className="flex items-start gap-2">
  <img
    src="/images/GroupLocation.svg"
    alt="Location"
    className="w-4 h-4 mt-0.5 flex-shrink-0"
  />

  {contact?.href ? (
    <a
      href={contact.href}
      target="_blank"
      rel="noopener noreferrer"
      className="ava-text-footer hover:underline max-w-[260px] inline-block whitespace-normal break-words"
      style={{ color: "white" }}
    >
      {contact.addressLine1}
      <br />
      {contact.addressLine2}
    </a>
  ) : (
    <span
      className="ava-text-footer"
      style={{ color: "white" }}
    >
      {contact?.addressLine1}
      <br />
      {contact?.addressLine2}
    </span>
  )}
</li>   
              </ul>
            </div>
          </div>

          {/* Newsletter (optional) */}
          {/* Uncomment if you want to use it later

          <div className="mt-10">
            <h3>{newsletter?.heading}</h3>
            <p>{newsletter?.subtext}</p>

            <form onSubmit={handleSubmit}>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={newsletter?.placeholder}
              />
              <button type="submit">Subscribe</button>
            </form>

            {submitted && <p>Subscribed successfully!</p>}
          </div>

          */}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="w-full ava-footer-bg">
        <div className="px-6 md:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="ava-text-footer text-white opacity-90 text-center sm:text-left">
              {legal?.copyright}
            </p>

            <div className="flex items-center gap-1 ava-text-footer text-white opacity-90">
              {legalLinks.map((link, index) => {
                const isExternal = /^https?:\/\//.test(link.href);

                return (
                  <React.Fragment key={link.id}>
                    {index > 0 && (
                      <span className="opacity-60 px-1">|</span>
                    )}

                    <a
                      href={link.href}
                      target={isExternal ? '_blank' : undefined}
                      rel={isExternal ? 'noopener noreferrer' : undefined}
                      className="hover:underline transition-opacity hover:opacity-100"
                    >
                      {link.label}
                    </a>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;